import React, { useEffect, useMemo, useState, useCallback } from "react";
import "./Archivio.scss";
import { useNavigate } from "react-router-dom";
import DataTableSubHeader from "../../Components/DataTableSubHeader/DataTableSubHeader.jsx";
import { EyeIcon, DeleteIcon } from "../../assets/icons/index.js";
import { useAppContext } from "../../Components/Context/AppContext.jsx";
import { getArchivio, deleteArchivio } from "../../api/archivio.js";
import { SubHeaderMobileOption } from "../../Components/SubHeaderMobileOption/SubHeaderMobileOption.jsx";
import { subHeaderRightNavOptions } from "../../Components/Archivio/SubHeaderNavOption/SubHeaderNavOption.jsx";
import datastructure from "../../constants/dataStructure/archivio.json";
import ItemsTable from "../../Components/ItemsTable/ItemsTable.jsx";
import { toast } from "react-toastify";
import userHasPermission from "../../helpers/formTools/userHasPermission/index.js";
import useFetchData from "../../hooks/useFetchData.js";
import ReactModal from "../../Components/ReactModal/ReactModal.jsx";
import FilterModal from "../../Components/FilterModal/FilterModal.jsx";
import Spinner from "../../Components/ProgressBar/Spinner.js";
import { getComuni } from "../../api/index.js";

const breadcrumbsData = [
  { id: 1, label: "Dati Archeologici", iconUrl: true },
  { id: 2, label: "Archivio storico", iconUtl: true },
  { id: 3, label: "Elenco fascicoli", iconUrl: "" },
];

const headers = [
  { key: "actions", label: "", width: "50px", sortable: false },
  { key: "protocollo", label: "Protocollo", width: "250px", sortable: false },
  {
    key: "fascicolo",
    label: "Numero fascicolo",
    width: "100px",
    sortable: false,
  },
  { key: "posizione", label: "Posizione", width: "100px", sortable: false },
  { key: "categoria", label: "Categoria", width: "100px", sortable: false },
  { key: "georeferenziazioni", label: "Riferimento geografico", width: "250px", sortable: false },

];

const filterValues = [
  { label: "Protocollo", key: "protocollo" },
  { label: "Numero fascicolo", key: "fascicolo" },
  { label: "Posizione", key: "posizione" },
  { label: "Categoria", key: "categoria" },
  { label: "Riferimento GIS", key: "georeferenziazione.valore" },
];

function Archivio() {
  const { setArchivioFilter, archivioFilter, setArchivioId, userProfile, setComuni } =
    useAppContext();
  const navigate = useNavigate();
  const [isMenuActive, setMenuActive] = useState(false);
  const [recordFilterModalOpen, setRecordFilterModalOpen] = useState(false);
  const [filterValue, setFilterValue] = useState({});
  
  const {
    data,
    isLoading,
    currentPage,
    recordsPerPage,
    totalRecords,
    totalPages,
    sortDirection,
    setCurrentPage,
    setRecordsPerPage,
    setSortDirection,
  } = useFetchData(getArchivio, archivioFilter);

  const organization = JSON.parse(localStorage.getItem("organization"));

  const userCanRead = userHasPermission({
    userProfile,
    organization,
    resource: "ARCHIVIOSTORICO",
    permission: "READ",
  });

  const userCanWrite = userHasPermission({
    userProfile,
    organization: organization,
    resource: "ARCHIVIOSTORICO",
    permission: "WRITE",
  });

  const userCanDelete = userHasPermission({
    userProfile,
    organization: organization,
    resource: "ARCHIVIOSTORICO",
    permission: "DELETE",
  });

  const toggleMenuActive = useCallback(
    () => setMenuActive(!isMenuActive),
    [isMenuActive]
  );


  const removeArchivio = useCallback(async (id) => {
    try {
      await deleteArchivio(id);
      toast.success("Data deleted successfully!");
      setTimeout(() => {
        window.location.reload();
      }, 20);
    } catch (error) {
      toast.error("Error deleting data");
    }
  }, []);

  const handlePageChange = useCallback(
    (newPage) => {
      setCurrentPage(newPage);
    },
    [setCurrentPage]
  );

  const handleRecordsPerPageChange = useCallback(
    (newRecordsPerPage) => {
      setRecordsPerPage(newRecordsPerPage);
      setCurrentPage(1); // Reset to first page when records per page changes
    },
    [setRecordsPerPage, setCurrentPage]
  );

  const handleCallBackSort = useCallback(
    async (key) => {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
      setArchivioFilter([{ key: "sort", value: `${key},${sortDirection}` }]);
    },
    [setSortDirection, setArchivioFilter, sortDirection]
  );

  const handleFilterIconClick = useCallback(() => {
    setRecordFilterModalOpen(true);
  }, []);

  const closeRecordFilterModal = useCallback(() => {
    setRecordFilterModalOpen(false);
  }, []);

  const handleCallBackFilter = useCallback(
    (data) => {
      const filter = data.map((item) => {
        return {
          key: filterValues?.find((f) => f.label === item.label)?.key,
          value: item.value,
        };
      });
      setArchivioFilter(filter);
      return true;
    },
    [setArchivioFilter]
  );

  /* ********************************************************* */
  // ALL EFFECTS

  // GET THE UPDATED LIST OF MUNICIPALITIES
 
  useEffect(() => {
    listComuni();
    return () => {};
  }, []);

  // useEffect(() => {
  //   getArchivioData();
  // }, [getArchivioData]);

    /* ************************************************************ */
  // ALL API CALLS

  const listComuni = async () => {
    try {
      const comuni = await getComuni([
        { key: "pageSize", value: 1000 },
        { key: "page", value: 1 },
      ]);
      if (Array.isArray(comuni.results)) {
        setComuni(comuni.results);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate("/");
        throw new Error(`Authorization error fetching "comuni"`);
      } else {
        toast.error(`Errore di connessione`);
      }
    }
  };

  const convertedData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    let mappedData = []; // Initialize the array to store the converted data

    data.forEach((item) => {
      const result = item;

      let jsonObject = { id: { value: result.id }, actions: { value: [] } }; // Initialize the row object

      // Convert row attributes in the right format base on a key and a value to be displayed
      for (const key in result) {
        if (result.hasOwnProperty(key)) {
          let value;
          if (key === 'georeferenziazioni') {
            value = result[key].map((item) => item.tipo + ": " + item.valore).join(", ");
          } else {
            value =
              result[key] !== undefined && result[key] !== null
                ? result[key].toString()
                : "";
          }
          jsonObject[key] = {
            value,
          };
        }
      }

      // Identifies the ID of the record
      const Id = jsonObject.id.value.replace(/^"|"$/g, "");

      // Add the actions to the row
      jsonObject.actions = {
        value: [],
        component: (
          <>
            <div
              onClick={() => {
                navigate("/archivio/view");
                setArchivioId(Id);
              }}
              className="row-icon"
              style={{ cursor: "pointer" }}
            >
              <EyeIcon fillColor="var(--archeo-color)" />
            </div>
            {userCanDelete && (
              <div
                onClick={() => removeArchivio(Id)}
                style={{ cursor: "pointer" }}
              >
                <DeleteIcon fillColor="var(--archeo-color)" />
              </div>
            )}
          </>
        ),
      };
      mappedData.push(jsonObject);
    });

    return mappedData;
  }, [data, setArchivioId, userProfile, removeArchivio, navigate]);

  console.log("userCanWrite ARCHIVIOSTORICO -->>", userCanWrite);

  return (
    <>
      <div className="container">
        <main className="record-main-content">
          <DataTableSubHeader
            title={"ARCHIVIO STORICO"}
            breadcrumbsData={breadcrumbsData}
            subHeaderRightNavOptions={subHeaderRightNavOptions(
              userCanWrite,
              convertedData,
              handleFilterIconClick,
              navigate
            )}
            isMenuActive={isMenuActive}
            setMenuActive={toggleMenuActive}
          />
          {isLoading ? (
            <Spinner />
          ) : (
            <ItemsTable
              headers={headers}
              data={convertedData}
              filterValues={filterValues}
              totalRecords={totalRecords}
              currentPage={currentPage}
              recordsPerPage={recordsPerPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onRecordsPerPageChange={handleRecordsPerPageChange}
              callBackSort={handleCallBackSort}
              userCanRead={userCanRead}
            />
          )}
        </main>
        <ReactModal
          isOpen={recordFilterModalOpen}
          onClose={closeRecordFilterModal}
        >
          <FilterModal
            closeModal={closeRecordFilterModal}
            filterValues={filterValues}
            setFilterValue={setFilterValue}
            callBackFilter={handleCallBackFilter}
            onReset={() => { window.location.reload(); }}
          />
        </ReactModal>
        {isMenuActive && (
          <SubHeaderMobileOption
            components={
              subHeaderRightNavOptions(userCanWrite, navigate)?.components
            }
            icons={subHeaderRightNavOptions(userCanWrite, navigate)?.icons}
            onCrossClick={() => setMenuActive(false)}
            title="options"
          />
        )}
      </div>
    </>
  );
}

export default Archivio;
